var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-code-editor"},[(_vm.label)?_c('label',{staticClass:"v-label theme--light"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{ref:"editor",staticClass:"code-editor-wrapper"})])}
var staticRenderFns = []

export { render, staticRenderFns }